import { render, staticRenderFns } from "./tableSve&Risk.vue?vue&type=template&id=62b5ee3f"
import script from "./tableSve&Risk.vue?vue&type=script&lang=js"
export * from "./tableSve&Risk.vue?vue&type=script&lang=js"
import style0 from "./tableSve&Risk.vue?vue&type=style&index=0&id=62b5ee3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports